import { cn } from "@/lib/utils.js";
import type { HTMLAttributes } from "react";

type PersonaVoiceSize = "sm" | "base" | "lg";

const sizeClasses: Record<PersonaVoiceSize, string> = {
  sm: "text-sm",
  base: "text-md",
  lg: "text-lg",
};

interface PersonaVoiceProps extends HTMLAttributes<HTMLQuoteElement> {
  size?: PersonaVoiceSize;
  cite?: string;
}

/**
 * Serif italic in primary blue — a persona speaking, quoted. The product's
 * signature voice moment: the only place italics appear outside quotes.
 */
export function PersonaVoice({
  size = "sm",
  cite,
  className,
  children,
  ...props
}: PersonaVoiceProps) {
  return (
    <blockquote
      className={cn(
        "font-serif italic text-primary",
        sizeClasses[size],
        className,
      )}
      {...props}
    >
      {cite ? (
        <>
          <p>{children}</p>
          <footer>
            <cite>{cite}</cite>
          </footer>
        </>
      ) : (
        children
      )}
    </blockquote>
  );
}
